// extracted by mini-css-extract-plugin
export default {"App":"App_App__B2Ebb","row":"App_row__-vzSq","required":"App_required__UO2NX","costBox":"App_costBox__DC5C9"};